import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';

import {Pessoa} from './../_shared/pessoa/pessoa';
import {PessoaService} from './../_shared/pessoa/pessoa.service';
import {SessionService} from './../_shared/session/session.service';
import {HeaderService} from '../_shared/http/header.service';
import {EnderecoService} from './../_shared/endereco/endereco.service';
import {Estado} from './../_shared/endereco/estado';

@Component({
    selector: 'app-pre-cadastro',
    templateUrl: './pre-cadastro.component.html',
    styleUrls: ['./pre-cadastro.component.css']
})
export class PreCadastroComponent implements OnInit {
    public pessoa: Pessoa = new Pessoa();
    public formulario: FormGroup;
    public validaFormulario = true;
    public estados: Estado[];

    public pes_nom_placeholder = 'Nome';
    public pes_nom_classe: string;

    public pes_sobrenome_placeholder = 'Sobrenome';
    public pes_sobrenome_classe: string;

    public pes_pass_num_placeholder = 'Passaporte';
    public pes_pass_num_classe: string;

    public pes_dat_nas_placeholder = 'Data de Nascimento';
    public pes_dat_nas_classe: string;

    public sexo_selecionado = 'Sexo';
    public pes_sexo_classe: string;
    public sexos = [
        {id: '2', text: 'Feminino'},
        {id: '1', text: 'Masculino'}
    ];

    public pes_cpf_placeholder = 'CPF';
    public pes_cpf_classe: string;

    public pes_mail_placeholder = 'e-mail';
    public pes_mail_classe: string;

    public pes_tel_res_placeholder = 'Telefone fixo';

    public pes_tel_cel_placeholder = 'Celular';
    public pes_tel_cel_classe: string;

    public estado_selecionado = 'UF *';

    public pes_cpf_mask = [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
    ];
    public pes_tel_cel_mask = [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ];
    public pes_tel_res_mask = [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ];

    public pode_editar = true;
    public pes_senha_editar = true;
    public pes_cpf_editar = true;

    constructor(
        private router: Router,
        private pessoaService: PessoaService,
        private EnderecoService: EnderecoService,
        private SessionService: SessionService,
        private HeaderService: HeaderService
    ) {
    }

    ngOnInit() {
        this.router.events.subscribe(evt => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        this.pessoa = this.pessoaService.getPessoa();


        this.podeEditarPessoa();
        this.podeEditarCpf();

    }

    somenteNumero(event: any) {
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);

        if (event.keyCode == '9' || event.keyCode == '8') {
            return true;
        }

        if (!pattern.test(inputChar)) {
            return false;
        }
    }

    podeEditarPessoa() {
        if (
            this.isEmptyTrim(this.pessoa.pes_rg) &&
            this.isEmptyTrim(typeof this.pessoa.pes_cpf) &&
            this.isEmptyTrim(this.pessoa.pes_rg_org_exp) &&
            this.isEmptyTrim(this.pessoa.pes_rg_uf)
        ) {
            this.pode_editar = false;
        }
    }

    isEmptyTrim(element) {
        return typeof element == 'string' && element.trim() !== '';
    }


    podeEditarCpf() {
        if (this.pessoa.pes_pass_num) {
            this.pes_cpf_editar = false;
        } else {
            this.pes_cpf_editar = true;
        }
    }

    removeClaseError() {
        this.pes_cpf_classe = '';
        this.pes_dat_nas_classe = '';
        this.pes_mail_classe = '';
        this.pes_nom_classe = '';
    }

    trataFormulario() {
        this.removeClaseError();

        this.formulario = new FormGroup({
            pes_nom: new FormControl(this.pessoa.pes_nom, [
                Validators.required,
                Validators.minLength(3),
                Validators.pattern(/^(((?!_)[A-zÀ-ÿ\-\'])[\s]*)+$/gi)
            ]),
            pes_sobrenome: new FormControl(this.pessoa.pes_sobrenome, [
                Validators.required,
                Validators.minLength(3),
                Validators.pattern(/^(((?!_)[A-zÀ-ÿ\-\'])[\s]*)+$/gi)
            ]),
            pes_mail: new FormControl(this.pessoa.pes_mail, [
                Validators.required,
                Validators.email
            ])
        });

        if (this.pes_cpf_editar) {
            // this.formulario.addControl(
            //     'pes_rg',
            //     new FormControl(this.pessoa.pes_rg, [Validators.required])
            // );
            // this.formulario.addControl(
            //     'pes_rg_org_exp',
            //     new FormControl(this.pessoa.pes_rg_org_exp, [Validators.required])
            // );
            // this.formulario.addControl(
            //     'pes_rg_uf',
            //     new FormControl(this.pessoa.pes_rg_uf, [Validators.required])
            // );
            this.formulario.addControl(
                'pes_cpf',
                new FormControl(this.pessoa.pes_cpf, [
                    Validators.required,
                    Validators.minLength(11)
                ])
            );
        } else {
            // this.formulario.addControl(
            //     'pes_pass_dat_val',
            //     new FormControl(this.pessoa.pes_pass_dat_val, [
            //         Validators.required,
            //         Validators.pattern(
            //             '^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$'
            //         )
            //     ])
            // );
            // this.formulario.addControl(
            //     'pes_pass_dat_exp',
            //     new FormControl(this.pessoa.pes_pass_dat_exp, [
            //         Validators.required,
            //         Validators.pattern(
            //             '^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$'
            //         )
            //     ])
            // );
            // this.formulario.addControl(
            //     'pes_visto_dat_val',
            //     new FormControl(this.pessoa.pes_visto_dat_val, [
            //         Validators.required,
            //         Validators.pattern(
            //             '^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$'
            //         )
            //     ])
            // );
            // this.formulario.addControl(
            //     'pes_visto_tipo',
            //     new FormControl(this.pessoa.pes_visto_tipo, [Validators.required])
            // );
            this.formulario.addControl(
                'pes_pass_num',
                new FormControl(this.pessoa.pes_pass_num, [
                    Validators.required,
                    Validators.minLength(5)
                ])
            );
            // this.formulario.addControl(
            //     'pes_rne',
            //     new FormControl(this.pessoa.pes_rne, [Validators.required])
            // );
        }

        // if (!this.pessoa.pes_tel_cel && !this.pessoa.pes_tel_res) {
        //     this.formulario.addControl(
        //         'pes_tel_cel',
        //         new FormControl(this.pessoa.pes_tel_cel, [Validators.required])
        //     );
        // }

        if (this.formulario.status === 'INVALID') {
            this.validaFormulario = false;

            this.validForm('pes_nom', 'Nome');
            this.validForm('pes_sobrenome', 'Sobrenome');
            this.validForm('pes_mail', 'e-mail');

            if (this.pes_cpf_editar) {
                this.validForm('pes_cpf', 'CPF');
            
            } else {
                this.validForm('pes_pass_num', 'Passaporte');

            }

        
            if (
                this.formulario.controls.pes_tel_cel &&
                !this.formulario.controls.pes_tel_cel.valid
            ) {
                this.pes_tel_cel_placeholder = 'Um dos telefones é obrigatório';
                this.pes_tel_cel_classe = 'classWarning';
            }

        }

        if (this.formulario.status === 'VALID') {
            this.validaFormulario = true;
        }

        if (!this.pode_editar) {
            const pessoaEditar = this.pessoaService.getPessoa();
            this.pessoa.pes_rg = pessoaEditar.pes_rg;
            this.pessoa.pes_cpf = pessoaEditar.pes_cpf;
            this.pessoa.pes_rg_org_exp = pessoaEditar.pes_rg_org_exp;
            this.pessoa.pes_rg_uf = pessoaEditar.pes_rg_uf;
        }
        let data = ''

        //this.proximo(data);
        // this.pessoaService.salvaPessoa(this.pessoa)
        //     .subscribe(
        //         data => this.proximo(data),
        //         error => {
        //             if (error.errors) {
        //                 this.trataErroWs(error.errors);
        //             } else {
        //                 throw new Error();
        //             }
        //         }
        //     );
        
        this.pessoaService.setPessoa(this.pessoa);
        this.pessoaService.gravaDadosInscricaoIncompleta()
            .subscribe(
                data => this.proximo(data),
                error => {
                    if (error.errors) {
                        this.trataErroWs(error.errors);
                    } else {
                        throw new Error();
                    }

                }
            );

        

    }

    validaDataMinima(data) {
        return data && new Date(data).getFullYear() >= new Date().getFullYear();
    }

    selecionaEstado(estado) {
        this.pessoa.pes_rg_uf = estado.text;
        this.pessoa.uf_cod_rg = estado.id;
    }

    selecionaSexo(sexo) {
        this.sexo_selecionado = sexo.text;
        this.pessoa.pes_sexo = sexo.id;
    }


    proximo(data) {
        if (this.validaFormulario) {

            this.router.navigate(['/dados-pessoais']);

        }
    }

    trataErroWs(errors) {
        Object.keys(errors).forEach(element => {
            this[element + '_placeholder'] = errors[element][0];
            this.pessoa[element] = '';
            this[element + '_classe'] = 'classErro';
        });
    }

    validForm(campo, nome) {
        if (!this.formulario.controls[campo].valid) {
            this[campo + '_classe'] = 'classErro';
            this[campo + '_placeholder'] = nome + ' está inválido';

            if (this.formulario.controls[campo].errors['required']) {
                this[campo + '_classe'] = 'classWarning';
                this[campo + '_placeholder'] = nome + ' é obrigatório';
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pre-cadastro/pre-cadastro.component.ts